export default __webpack_public_path__ + "static/media/коробочка .84be5061.jpg";